export interface IAppState {
    language: string
    serverTime: string | null
    error: boolean
    errorCode: number | undefined
    featureToggles: IFeatureToggles
    spinTheWheelOpen: boolean
    appLoading: boolean
}

export interface IPromoPoints {
    value: boolean
    points: number
}

export interface IFeatureToggles {
    login_required: boolean
    coming_soon: boolean
    promo_points: IPromoPoints
    bank_fee: number
}

export const initialFeatureToggles: IFeatureToggles = {
    login_required: false,
    coming_soon: false,
    promo_points: {
        value: false,
        points: 50
    },
    bank_fee: 0.017
}
